import { useState } from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from 'react-router-dom';
import { useAuth } from './configs/context/AuthContext';
// import axios from 'axios';

// import { loginApi } from './configs/api/endpoints';
import { LoginPopup, Navbar } from './components/parts';

import {
  Home,
  About,
  Dashboard,
  Facility,
  Questionnaire,
  DetailFacilityDashboard,
} from './pages';

function App() {
  const { isLogin } = useAuth();

  const [showLoginModal, setShowLoginModal] = useState(false);

  // effect auto login
  // useEffect(() => {
  //   const source = axios.CancelToken.source();
  //   const userData = {
  //     username: 2,
  //     password: 'password',
  //   };

  //   axios
  //     .post(loginApi, userData, {
  //       headers: {
  //         'Content-Type': 'application/json',
  //       },
  //       cancelToken: source.token,
  //     })
  //     .then((response) => {
  //       setAuthToken(response.data.token);
  //       console.log('hasil login', response);
  //       console.log('login sukses');
  //     })
  //     .catch((error) => {
  //       if (error.response) {
  //         console.log(error.response.data); // => the response payload
  //       }
  //     });

  //   return () => source.cancel();
  // }, []);

  return (
    <div className="App">
      <Router>
        <Navbar setShowLoginModal={setShowLoginModal} />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route
            path="/dashboard"
            element={isLogin ? <Dashboard /> : <Navigate replace to="/" />}
          />
          <Route
            path="/facility"
            element={isLogin ? <Facility /> : <Navigate replace to="/" />}
          />
          <Route
            path="/detail-facility"
            element={
              isLogin ? (
                <DetailFacilityDashboard />
              ) : (
                <Navigate replace to="/" />
              )
            }
          />
          <Route
            path="/questionnaire"
            element={isLogin ? <Questionnaire /> : <Navigate replace to="/" />}
          />
          <Route
            path="/facility-document"
            element={isLogin ? <Dashboard /> : <Navigate replace to="/" />}
          />
          <Route
            path="/company-dashboard"
            element={isLogin ? <Dashboard /> : <Navigate replace to="/" />}
          />
        </Routes>

        {showLoginModal && <LoginPopup setShowLoginModal={setShowLoginModal} />}
      </Router>
    </div>
  );
}

export default App;
